import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import withStyles from 'material-ui/styles/withStyles';
import styles from '../styles/GapPacketStyles';
import styled from 'styled-components';
import InputLabel from 'spark-ui/ui-kitchen/ingredients/spices/InputLabel';
import DateRangeField from 'spark-ui/form/DateRange/DateRange';
import SelectField from 'spark-ui/form/Select/FancySelect';
import NormalSelectField from 'spark-ui/form/Select/Select';
import { getMoleculesByEnterprise,  getStudy,  getSite } from 'spark-api/utilityService';
import Button from 'spark-ui/ui-kitchen/ingredients/spices/Button';
import { getGapPacketTitle, getGapPacketTitleForRecipient } from 'spark-api/gapPacket/gapPacketService';
import { MenuItem } from "material-ui/Menu";
import Permission from 'spark-util/Permission';

const SelectContainer = styled.div`
	width: 250px;
`;

const statusOptions = [
	{ value: 'Pending', label: 'Pending for Acknowledgement' },
	{ value: 'Completed', label: 'Acknowledged' }
];

const ProductField = (props) => {
	const dispatch = useDispatch();
	const options = useCallback((search) =>
		dispatch(getMoleculesByEnterprise(search)).then((response) =>
			response.data.map((molecule) => ({ value: molecule, label: molecule }))
		), [dispatch]);
	return <SelectField {...props} options={options} />;
};

const StudyField = (props) => {
	const dispatch = useDispatch();
	const options = useCallback((search) =>
		dispatch(getStudy(search)).then((response) =>
			response.data.map(({ studyId, studyName }) => ({
				value: studyName,
				label: studyName,
				idValue: studyId
			}))
		), [dispatch]);
	return <SelectField {...props} options={options} />;
};

const GapPacketTitle = (props) => {
	const dispatch = useDispatch();
	const options = useCallback((search) =>
		dispatch(getGapPacketTitle(search)).then(response =>
			response.data.map(title => ({
				value: title,
				label: title
			}))
		), [dispatch]);
	return <SelectField {...props} options={options} />;
};

const GapPacketTitleForRecipient = (props) => {
	const dispatch = useDispatch();
	const options = useCallback((search) =>
		dispatch(getGapPacketTitleForRecipient(search)).then(response =>
			response.data.map(title => ({
				value: title,
				label: title
			}))
		), [dispatch]);
	return <SelectField {...props} options={options} />;
};

const Site = (props) => {
	const dispatch = useDispatch();
	const options = useCallback((search) =>
		dispatch(getSite(search)).then(response =>
			response.data.map(({ orgName, orgId, siteNum }) => ({
				value: orgId,
				label: `${orgName} (${siteNum}) `,
				siteNum: siteNum,
				orgName: orgName
			}))
		), [dispatch]);
	return <SelectField {...props} options={options} />;
};

const GapPacketFormFields = ({ classes, control, setValue, clear, submit }) => {
	useEffect(() => {
		if (setValue) {
			setValue('status', 'Pending');
		}
	}, [setValue]);

	return (
	<div className={classes.bulkdownloadDetails}>
		<div className={classes.Div}>
			<div className={classes.row}>
				<InputLabel className={classes.label}>Title</InputLabel>
				{/* SAF-20237: Removed temporary ibCLSafetyRecipient prop (Role Assignment - Switch Roles and its Precedence - PSR-4763) */}
				<Permission recipientOnly>
					<SelectContainer>
				    	<GapPacketTitleForRecipient name="gpTitle" placeholder="Search..." single control={control}/>
					</SelectContainer>
				</Permission>
				<Permission requires='gp.manageGapPacket'>
					<SelectContainer>
				    	<GapPacketTitle name="gpTitle" placeholder="Search..." single control={control}/>
					</SelectContainer>
				</Permission>
			</div>
			<div className={classes.row}>
                <InputLabel className={classes.label} >
					Study
				</InputLabel>
				<SelectContainer>
					<StudyField name="study" placeholder="Search..." single control={control} />
				</SelectContainer>
			</div>		
		</div>
		<div className={classes.Div}>
			<div className={classes.row}> 
				<InputLabel className={classes.label}>
					Organization
				</InputLabel>
				<SelectContainer>
					<Site name='org' placeholder="Search..." single control={control} />
				</SelectContainer>
			</div>
			<div className={classes.row}>
                <InputLabel className={classes.label} >
					Distribution Date
				</InputLabel>
				<SelectContainer>
                    <DateRangeField name="distributionDate" inlineLabel control={control} />
				</SelectContainer>
			</div>
		</div>
		<div className={classes.Div}>
		    <div className={classes.row}>
                <InputLabel className={classes.label} >
					Product
				</InputLabel>
				<SelectContainer>
					<ProductField name="product" placeholder="Search..." single control={control} />
				</SelectContainer>	
			</div>
			{
			<div className={classes.row}>
				{/* SAF-20237: Removed temporary ibCLSafetyRecipient prop (Role Assignment - Switch Roles and its Precedence - PSR-4763) */}
				<Permission recipientOnly>
				<InputLabel className={classes.label}>Status</InputLabel>
				<NormalSelectField
					name="status"
					options={statusOptions}
					single
					control={control}
                    renderOption={status => (
                        <MenuItem
                            key={status.value}
                            value={status.value}
                        >
                            {status.label}
                    	</MenuItem>
                    )}
				/>
				</Permission>	
			</div>
					}
			
		</div>
        <div className={classes.Div}>
			<div className={classes.row}>
            </div>
			<div className={classes.row}></div>
			<div className={classes.buttonRow}>
				<Button secondary onClick={clear} className={classes.button}>Clear Fields</Button>
				<Button primary onClick={submit} className={classes.searchButton}> Search</Button>
			</div>
		</div>
	</div>
	);
};

export default withStyles(styles)(GapPacketFormFields);
